import { render, staticRenderFns } from "./returnLayout.vue?vue&type=template&id=60eed0c8&scoped=true&"
import script from "./returnLayout.vue?vue&type=script&lang=js&"
export * from "./returnLayout.vue?vue&type=script&lang=js&"
import style0 from "./returnLayout.vue?vue&type=style&index=0&id=60eed0c8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60eed0c8",
  null
  
)

export default component.exports